import { Pipe, PipeTransform } from '@angular/core';
import { FlagGroupTag, FlagSubGroup, FlagTemplate } from '../../shared/interfaces';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(groups: FlagGroupTag[], searchQuery: string): FlagGroupTag[] {
    if (!groups || !searchQuery) {
      return groups;
    }
    const lowerCaseQuery = searchQuery.toLowerCase();
    const highlightMatch = (name: string): string => {
      const regex = new RegExp(`(${searchQuery})`, 'gi');
      return name.replace(regex, `<b>$1</b>`);
    };
    const filterGroup = (group: FlagGroupTag): FlagGroupTag | null => {
      const groupMatches = group.name.toLowerCase().includes(lowerCaseQuery);
      const subgroupMatches = group.subgroups?.map((subGroup: FlagSubGroup) => {
        const matchesSubgroupName = subGroup.name?.toLowerCase().includes(lowerCaseQuery);

        const filteredTemplates = subGroup.templates?.map((template: FlagTemplate) => ({
          ...template,
          label: template.name.toLowerCase().includes(lowerCaseQuery) ? highlightMatch(template.name) : template.name,
        }));

        if (matchesSubgroupName) {
          return {
            ...subGroup,
            label: highlightMatch(subGroup.name),
            templates: filteredTemplates,
          };
        }

        const templateMatches = filteredTemplates?.some(template => template.label.includes('<b>'));

        if (templateMatches) {
          return {
            ...subGroup,
            templates: filteredTemplates,
          };
        }

        return null;
      });

      const hasSubgroupMatches = subgroupMatches?.some(subGroup => subGroup !== null);
      if (groupMatches || hasSubgroupMatches) {
        return {
          ...group,
          label: groupMatches ? highlightMatch(group.name) : group.name,
          subgroups: group.subgroups?.map(subGroup => ({
            ...subGroup,
            label: highlightMatch(subGroup.name),
            templates: subGroup.templates?.map(template => ({
              ...template,
              label: highlightMatch(template.name),
            })),
          })),
        };
      }
      return null;
    };
    return groups.map(group => filterGroup(group)).filter((group): group is FlagGroupTag => group !== null);
  }
}
